/** CP-060 — Route Correction Workspace tab. */
export function isRouteCorrectionWorkspaceEnabled(): boolean {
  return process.env.REACT_APP_ROUTE_CORRECTION_WORKSPACE !== 'false';
}

/** Legacy mutation tab (M1.3) — kept for cutover rollback. */
export function isLegacyMutationWorkspaceEnabled(): boolean {
  return process.env.REACT_APP_MUTATION_WORKSPACE === 'true';
}
